<template>

    <v-snackbar
    v-model="snackbarAdd"
    color="success"
    >            
        {{ snackMessage }}
    </v-snackbar>


    <v-snackbar
    v-model="snackbarEdit"
    color="orange-darken-2"
    >            
    {{ snackMessage }}
    </v-snackbar>


    <v-snackbar
    v-model="snackbarDelete"
    color="#FF3019"
    >            
        {{ snackMessage }}
    </v-snackbar>


    <v-snackbar
    v-model="snackbarError"
    color="error"
    >            
        {{ snackMessage }}
    </v-snackbar>      

</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex';

const store             = useStore();

const snackbarAdd       = computed( ()=> store.state.snackbarAdd    );
const snackbarEdit      = computed( ()=> store.state.snackbarEdit   );
const snackbarError     = computed( ()=> store.state.snackbarError  );
const snackbarDelete    = computed( ()=> store.state.snackbarDelete );
const snackMessage      = computed( ()=> store.state.snackbarmsg    );
       
</script>